import { createContext } from 'react';

/**
 * "Is this felt a tile the tiled carousel is SHOWING right now?"
 *
 * Supplied by RebindingTableView: true for each panel on its track while two or
 * more tables share the viewport (`tablesInView > 1`), false for a panel it
 * holds parked off-track, and false everywhere at one table in view.
 *
 * Exists for `useTableSnap` (EN-11150). In a tiled layout only the focused tile
 * is the active table, yet every tile on the track is in plain view, so the
 * others must keep animating. Neither neighbouring signal can say that alone:
 * `TableOnScreenContext` is also true for every cell of a shown multi-table
 * grid, including cells scrolled out of its row, and `GridModeContext` is true
 * for parked tiles too.
 *
 * Defaults to `false`: outside the carousel nothing is a tile.
 */
export const VisibleTileContext = createContext<boolean>(false);

export const VisibleTileProvider = VisibleTileContext.Provider;

export default VisibleTileContext;
